export const orderRouter = {
    name: 'order',
    component: () => import(/* webpackChunkName: "cart" */ '@/modules/order/pages/OrderPage'),
}

